import { render, staticRenderFns } from "./FormChooseDowngrade.vue?vue&type=template&id=c22748d4&scoped=true&"
import script from "./FormChooseDowngrade.vue?vue&type=script&lang=js&"
export * from "./FormChooseDowngrade.vue?vue&type=script&lang=js&"
import style0 from "./FormChooseDowngrade.vue?vue&type=style&index=0&id=c22748d4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22748d4",
  null
  
)

export default component.exports